function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "D51F6AA7-5D38-499F-9667-D3FDC4FBB4CF");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-382.000000, -506.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(0.000000, 162.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "24px_20",
  transform: "translate(162.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "2.82440737e-13 5.32907052e-15 24.0124766 5.32907052e-15 24.0124766 24 2.82440737e-13 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0067582,3 L11.0057184,3 L11.0057184,13 L13.0067582,13 L13.0067582,3 Z M17.8392691,5.17 L16.4185309,6.59 C17.9993523,7.86 19.0098773,9.81 19.0098773,12 C19.0098773,15.87 15.8782502,19 12.0062383,19 C8.13422645,19 5.00259929,15.87 5.00259929,12 C5.00259929,9.81 6.01312435,7.86 7.58394053,6.58 L6.17320753,5.17 C4.232199,6.82 3.00155958,9.26 3.00155958,12 C3.00155958,16.97 7.03365461,21 12.0062383,21 C16.978822,21 21.010917,16.97 21.010917,12 C21.010917,9.26 19.7802776,6.82 17.8392691,5.17 Z",
  id: "Shape",
  fill: "currentColor",
  fillRule: "nonzero"
})))))))));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.c5f11c71.svg";
export { ForwardRef as ReactComponent };